// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: the round mark automated mail gets in place of initials (the FYI card's
// groups and inbox rows): the service's logo, a rocket for build and deploy
// runs, a newspaper for digests. GitHub puts the actor's name on its mail, so
// without this a notification looked like a mail from that person.

import styles from '@app/features/konvo_mail/components/MailFyiCard.module.css';
import {ClickUpLogo} from '@app/features/ui/components/icons/ClickUpLogo';
import {BellIcon, CalendarCheckIcon, GithubLogoIcon, NewspaperIcon, RocketIcon} from '@app/features/ui/icons/Icons';
import {clsx} from 'clsx';

export type MailMarkKind = 'notification' | 'run' | 'digest' | 'meeting_reply' | 'asks_you' | 'failed';

/** The icon alone, for a round that already has its own look (the inbox row's avatar). */
export function MailMarkIcon({kind, source, size}: {kind: MailMarkKind; source: string; size: number}) {
	if (kind === 'run' || kind === 'failed') return <RocketIcon size={size} />;
	if (kind === 'digest') return <NewspaperIcon size={size} />;
	if (kind === 'meeting_reply') return <CalendarCheckIcon size={size} />;
	if (/^github/i.test(source)) return <GithubLogoIcon size={size} />;
	if (/^clickup/i.test(source)) return <ClickUpLogo size={size} />;
	return <BellIcon size={size} />;
}

export function MailFyiMark({
	kind,
	source,
	size = 20,
	className,
}: {
	kind: MailMarkKind;
	source: string;
	size?: number;
	className?: string;
}) {
	return (
		<span className={clsx(styles.mark, className)} aria-hidden="true">
			<MailMarkIcon kind={kind} source={source} size={size} />
		</span>
	);
}
